import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/less_than_black.svg'
import _imports_1 from '@/assets/images/date_range_black.svg'
import _imports_2 from '@/assets/images/question_mark_FILL.svg'


const _hoisted_1 = { class: "objective-creation-view-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = { class: "objective-creation-view-title-text h5" }
const _hoisted_4 = { class: "objective-name-input-field-wrapper" }
const _hoisted_5 = { class: "objective-name-input-field-first-row" }
const _hoisted_6 = { class: "asterisk-icon default-text-orange" }
const _hoisted_7 = ["maxlength"]
const _hoisted_8 = { class: "objective-name-input-field-second-row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "new-ojective-text-due default-text" }, "Due date", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  class: "calendar-icon",
  src: _imports_1
}, null, -1)
const _hoisted_11 = { class: "objective-creation-date-picker-wrapper" }
const _hoisted_12 = { class: "project-selection-block" }
const _hoisted_13 = { class: "project-name-input-field-first-row" }
const _hoisted_14 = { class: "asterisk-icon default-text-orange" }
const _hoisted_15 = { class: "project-block" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "project-name-input-field-second-row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "new-ojective-text-estimated default-text" }, " Estimated time ", -1)
const _hoisted_19 = { class: "question-fill-block" }
const _hoisted_20 = { class: "question-fill-block-element-wrapper" }
const _hoisted_21 = ["maxlength", "placeholder"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  class: "question-icon",
  src: _imports_2
}, null, -1)
const _hoisted_23 = { class: "question-fill-block-element-wrapper" }
const _hoisted_24 = ["maxlength", "placeholder"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  class: "question-icon",
  src: _imports_2
}, null, -1)
const _hoisted_26 = { class: "question-fill-block-element-wrapper" }
const _hoisted_27 = ["maxlength", "placeholder"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  class: "question-icon",
  src: _imports_2
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "objective-creation-divider" }, null, -1)
const _hoisted_30 = { class: "objevtive-creation-button-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_time_selector = _resolveComponent("time-selector")!
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_ta_button = _resolveComponent("ta-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: "objective-creation-view-back-button small-text-grey",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.leavePage()))
      }, [
        _hoisted_2,
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("component-new-task-view.back")), 1)
      ]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("local-task-component-locales.new-objectice")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.requiredSymbol), 1),
          _createElementVNode("input", {
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateobjectiveNameValue && _ctx.updateobjectiveNameValue(...args))),
            onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateobjectiveNameValue && _ctx.updateobjectiveNameValue(...args))),
            maxlength: _ctx.Length120,
            ref: "objectiveNameInput",
            class: "objective-name-area small-text",
            type: "text",
            placeholder: "Objective name"
          }, null, 40, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_Datepicker, {
              modelValue: _ctx.date,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.date) = $event)),
              onCleared: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clearDate())),
              onClosed: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getDateValue(_ctx.date))),
              autoApply: "",
              monthChangeOnScroll: 'inverse',
              format: _ctx.format,
              closeOnAutoApply: true,
              enableTimePicker: false,
              minDate: _ctx.minmalAllowedValue
            }, null, 8, ["modelValue", "format", "minDate"])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["small-text-salmon error-message-objective-creation", { hideElement: _ctx.hideFirstError }])
      }, _toDisplayString(_ctx.firstErrorMessageText), 3),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.requiredSymbol), 1),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taProject, (project, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["project-element default-text", {
                  'project-selected': _ctx.selectedProjectName === project.name,
                }]),
                  onClick: ($event: any) => (_ctx.selectProject(project))
                }, _toDisplayString(project.name), 11, _hoisted_16)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(_component_time_selector, { class: "object-creation-view-time-selector" }),
          _createElementVNode("div", {
            class: _normalizeClass(["small-text-salmon error-message-objective-creation", { hideElement: _ctx.hideSecondError }])
          }, _toDisplayString(_ctx.secondErrorMessageText), 3)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("input", {
            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updatedQuestion(_ctx.who))),
            onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updatedQuestion(_ctx.who))),
            maxlength: _ctx.Length120,
            ref: "whoRef",
            class: "question-name-area small-text",
            type: "text",
            placeholder: _ctx.whoTranslationKey
          }, null, 40, _hoisted_21),
          _createVNode(_component_tooltip, {
            text: _ctx.whoTooltip,
            positionFromTop: 'small'
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          }, 8, ["text"])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("input", {
            onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updatedQuestion(_ctx.what))),
            onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updatedQuestion(_ctx.what))),
            maxlength: _ctx.Length120,
            ref: "whatRef",
            class: "question-name-area small-text",
            type: "text",
            placeholder: _ctx.whatTranslationKey
          }, null, 40, _hoisted_24),
          _createVNode(_component_tooltip, {
            text: _ctx.whatTooltip,
            positionFromTop: 'small'
          }, {
            default: _withCtx(() => [
              _hoisted_25
            ]),
            _: 1
          }, 8, ["text"])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("input", {
            onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updatedQuestion(_ctx.why))),
            onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updatedQuestion(_ctx.why))),
            maxlength: _ctx.Length120,
            ref: "whyRef",
            class: "question-name-area small-text",
            type: "text",
            placeholder: _ctx.whyTranslationKey
          }, null, 40, _hoisted_27),
          _createVNode(_component_tooltip, {
            text: _ctx.whyTooltip,
            positionFromTop: 'small'
          }, {
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          }, 8, ["text"])
        ])
      ]),
      _hoisted_29,
      _createElementVNode("textarea", {
        onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateOptionalText())),
        type: "text",
        ref: "objectiveDescription",
        class: "objective-optional-description-block small-text",
        placeholder: "Describe the main goal (optional)"
      }, null, 544),
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_ta_button, {
          class: "cancel-button-local",
          text: _ctx.cancelText,
          backgroundColor: 'gray-dark-text',
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.leavePage()))
        }, null, 8, ["text"]),
        _createVNode(_component_ta_button, {
          class: "next-button",
          text: _ctx.saveText,
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.saveObjective()))
        }, null, 8, ["text"])
      ])
    ])
  ]))
}